import Input from '@material-ui/core/Input';
import React from 'react'
import { SearchIcon } from './icons'
import { withStyles } from '@material-ui/core/styles';

const styleSheet = {
    container: {
        display: 'flex',
        justifyContent: 'Flex-start',
        alignItems: 'center',
        borderRadius: 2,
        backgroundColor: '#FFFFFF',
        boxShadow: "0 0 2px 0 rgba(0,0,0,0.12), 0 2px 2px 0 rgba(0,0,0,0.24)",
        height: "40px",
    },

    container_disabled: {
        extend: 'container',
        backgroundColor: '#f2f2f2'
    },

    icon: {
        margin: "2px 25px 0 19px",
    },
    input_wrapper: {
        marginLeft: 0,
        marginRight: 25,
        width: '100%',
        fontSize: 14,
    },
};

const SearchBar = ({ classes, onChange, placeholder = "Search", disabled = false, autoFocus = true, delayFocus= false, ...props }) => {        
    return (
        <div className={disabled ? classes.container_disabled : classes.container}>
            <SearchIcon className={classes.icon} />
            <Input                
                inputProps={{
                    'aria-label':placeholder
                }}
                autoFocus={autoFocus}
                placeholder={placeholder}
                className={classes.input_wrapper}
                onChange={(e) => onChange(e.target.value)}
                disabled={disabled}
                disableUnderline={true}
                inputRef={delayFocus ? input => input && setTimeout(() => { input.focus()}, 100): undefined}
                {...props}
            />
        </div>
    );
};

// class SearchBar extends Component {
//     constructor(props) {
//         super(props);
//         this.state = {
//             searchPhrase: '',
//             onChangeFunc: props.onChange
//         }
//     }

//     onChange = (value) => {
//         this.setState({ searchPhrase: value })
//         this.state.onChangeFunc(value);
//     }

//     render() {
//         const { classes, onChange = () => {}, placeholder = "Search", disabled = false, autoFocus = true} = this.props;
//         return (
//             <div className={disabled ? classes.container_disabled : classes.container}>
//                 <SearchIcon className={classes.icon} />
//                 <Input
//                     autoFocus={autoFocus}
//                     placeholder={placeholder}
//                     className={classes.input_wrapper}
//                     onChange={(e) => onChange(e.target.value)}
//                     disabled={disabled}
//                     disableUnderline={true}
//                     {...this.props}
//                 />
//             </div>
//         );
//     }
// }


export default withStyles(styleSheet, { name: 'SearchBar' })(SearchBar);


